<template>

  <div>
    <form novalidate class="md-layout">
      <md-card class="md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Ordine di carico</div>
        </md-card-header>
        <md-card-content>
          <div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-30">
                <md-vuelidated>
                  <label for="deliveryNote">Delivery note</label>
                  <md-input type="text" v-model="fields.deliveryNote" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-30">
                <md-vuelidated>
                  <label for="elogate">ELOGATE</label>
                  <md-input type="text" v-model="fields.elogate" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <div v-show="edit">
                  <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.orderDate" md-immediately :disabled="!edit">
                    <label for="orderDate">Order Date</label>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
                <div v-show="!edit" class="input-display">
                  <label for="orderDate">Order Date</label>
                  <div class="input-value">{{fields.orderDate | formatDate}}</div>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <div v-show="edit">
                  <md-vuelidated field="md-datepicker" class="maxwidth220" v-model="fields.deliveryDate" md-immediately :disabled="!edit">
                    <label for="deliveryDate">Delivery Date</label>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
                <div v-show="!edit" class="input-display">
                  <label for="deliveryDate">Delivery Date</label>
                  <div class="input-value">{{fields.deliveryDate | formatDate}}</div>
                </div>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-vuelidated>
                  <label for="transportMean">Transport mean</label>
                  <md-input type="text" v-model="fields.transportMean" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <div class="field-wrapper">
                  <md-vuelidated>
                    <label for="grossWeight">Gross weight</label>
                    <md-input v-model="fields.grossWeight.quantity" :disabled="!edit" separator="." v-bind:precision="2"></md-input>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>

                  <md-vuelidated>
                    <md-select v-model="fields.grossWeight.unit" name="grossWeightUnit" id="grossWeightUnit" :disabled="!edit">
                      <md-option value="KG">KG</md-option>
                    </md-select>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <div class="field-wrapper">
                  <md-vuelidated>
                    <label for="netWeight">Net weight</label>
                    <md-input v-model="fields.netWeight.quantity" :disabled="!edit" separator="." v-bind:precision="2"></md-input>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                  <md-vuelidated>
                    <md-select v-model="fields.netWeight.unit" name="netWeightUnit" id="netWeightUnit" :disabled="!edit">
                      <md-option value="KG">KG</md-option>
                    </md-select>
                    <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  </md-vuelidated>
                </div>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-vuelidated>
                  <label for="depot">Magazino</label>
                  <md-select name="depot" v-model="fields.depot" :disabled="!edit">
                    <md-option v-for="(item, idx) in depots"
                               v-bind:key="idx"
                               :value="idx"><span v-html="item"></span>
                    </md-option>
                  </md-select>
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                  <md-vuelidated-msg constraint="notEmpty">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated>
                  <label for="pos">Pos</label>
                  <md-input type="text" v-model="fields.pos" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-vuelidated>
                  <label for="numeroMagazzino">Numero magazino</label>
                  <md-input type="text" v-model="fields.numeroMagazzino" :disabled="!edit" />
                  <md-vuelidated-msg constraint="required">Cambo obbligatorio</md-vuelidated-msg>
                </md-vuelidated>
              </div>
            </div>
            <div class="md-layout form-action">
              <md-button type="button"
                         class="md-primary md-raised"
                         :disabled="saving"
                         v-show="!edit"
                         @click="modify()">Modifica</md-button>
               <md-button type="button"
                        class="md-primary md-raised"
                        :disabled="saving"
                        v-show="!edit"
                        to="/carico">Indietro</md-button>
              <md-button type="button"
                         class="md-primary md-raised"
                         :disabled="saving"
                         v-show="edit"
                         @click="save()">Conferma</md-button>
              <md-button type="button" class="md-primary" :disabled="saving" v-show="edit" @click="reload()">Annulla</md-button>
            </div>
            <div class="md-layout">
              <md-toolbar md-elevation="0">
                <h3 class="md-title" style="flex: 1">Dettaglio</h3>
                <md-button class="md-icon-button" @click="addRow()" v-show="fields.id">
                  <md-icon>add</md-icon>
                </md-button>
              </md-toolbar>
              <md-table class="fullScreen">
                <md-table-row>
                  <md-table-head>POS</md-table-head>
                  <md-table-head>Mat. Number (SAP)</md-table-head>
                  <md-table-head class="desc">Description</md-table-head>
                  <md-table-head>Pcs/Unit</md-table-head>
                  <md-table-head>Packaging amount</md-table-head>
                  <md-table-head>Quantity</md-table-head>
                  <md-table-head>Weight</md-table-head>
                  <md-table-head class="action">&nbsp;</md-table-head>
                </md-table-row>
                <template v-for="row in sortedRows">
                      <md-table-row :key="row.pos">
                        <md-table-cell md-numeric>{{row.pos}}</md-table-cell>
                        <md-table-cell>{{row.materialNumber}}</md-table-cell>
                        <md-table-cell  class="desc">{{row.description}}</md-table-cell>
                        <md-table-cell>{{row.pcsUnit.quantity}} / {{row.pcsUnit.unit}}</md-table-cell>
                        <md-table-cell>{{row.packagingAmount.quantity}} / {{row.packagingAmount.unit}}</md-table-cell>
                        <md-table-cell>{{row.quantity.quantity}} / {{row.quantity.unit}}</md-table-cell>
                        <md-table-cell>{{row.weight.quantity}} / {{row.weight.unit}}</md-table-cell>
                        <md-table-cell>
                          <md-button class="md-icon-button" @click="onEditRow(row)" :disabled="edit">
                            <md-icon>edit</md-icon>
                          </md-button>
                          <md-button class="md-icon-button" @click="onDeleteRow(row)" :disabled="edit">
                            <md-icon>delete_forever</md-icon>
                          </md-button>
                          <md-button class="md-icon-button" @click="print(row)" :disabled="edit">
                            <md-icon>print</md-icon>
                          </md-button>
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row :key="row.pos" class="sscc">
                        <md-table-cell colspan="8">
                          <div class="ssccToolbar">
                            <strong>SSCC No.:</strong>
                            <md-button class="md-icon-button md-dense" @click="addSSCC(row.id)">
                              <md-icon>add</md-icon>
                            </md-button>
                          </div>
                          <div class="ssccList">
                            <div class="ssccNumber" v-for="sscc in row.ssccNumber" :key="sscc.number" :class="{'broken' : sscc.rotto}">
                              <span>{{sscc.pallet}}</span>
                              <span>
                                <md-button class="md-icon-button md-dense" @click="brokenSSCC(sscc)">
                                  <md-icon>broken_image</md-icon>
                                </md-button>
                                <md-button class="md-icon-button md-dense" @click="removeSSCC(sscc)">
                                  <md-icon>delete</md-icon>
                                </md-button>
                                <md-button class="md-icon-button md-dense" @click="editSSCC(sscc)">
                                  <md-icon>edit</md-icon>
                                </md-button>
                              </span>
                            </div>
                          </div>
                        </md-table-cell>
                      </md-table-row>
                    </template>
              </md-table>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button type="button" class="md-primary md-raised" :disabled="saving" @click="abort()">Chiudi</md-button>
        </md-card-actions>
      </md-card>
      <CaricoRowEdit :showEditRowDialog="showEditRowDialog" @close-edit="showEditRowDialog = false" v-bind:currentRow="editRowData"
                     v-on:save-row="onSaveRow"></CaricoRowEdit>
      <CaricoSSCCEdit :showEditSSCCDialog="showEditSSCCDialog"
                      @close-sscc-edit="showEditSSCCDialog = false"
                      v-bind:editSSCData="editSSCData"
                      v-on:save-sscc-row="onSavePalletRow"></CaricoSSCCEdit>
  </div>

</template>
<script>

  import moment from 'moment'
  import axios from 'axios'
  import print from 'print-js'
  import { validationMixin } from 'vuelidate'
  import CaricoRowEdit from './CaricoRowEdit.vue'
  import CaricoSSCCEdit from './CaricoSSCCEdit.vue'
  import ErrorService from "../Services/ErrorService";

  import { required } from 'vuelidate/lib/validators'

  const instance = axios.create({
    baseURL: window.appCfg.serviceURI
  })

  instance.interceptors.request.use(config => {
    config.headers.common['Access-Control-Allow-Origin'] = '*'
    return config
  })

  export default {
    name: 'CaricoEdit',
    mixins: [validationMixin],
    components: {
      CaricoRowEdit,
      CaricoSSCCEdit
    },
    data: function() {
      return {
        showEditRowDialog: false,
        showEditSSCCDialog: false,
        editRowData: {},
        editSSCData: {},
        depots: {},
        edit: true,
        fields: {
          id: 0,
          details: [],
          orderDate: new Date(),
          deliveryDate: new Date(),
          deliveryNote: '',
          transportMean: '',
          pos: '',
          depot: 0,
          numeroMagazzino: '',
          grossWeight: {
            quantity: '',
            unit: 'KG'
          },
          netWeight: {
            quantity: '',
            unit: 'KG'
          }
        },
        editRow: false
      }
    },
    validations: {
      fields: {
        deliveryNote: {
          required
        },
        elogate: {
          required
        },
        pos: {
          required
        },
        depot: {
          required,
          notEmpty : function(value) {
            return parseInt(value) > 0
          }
        },
        numeroMagazzino: {
          required
        },
        orderDate: {
          required
        },
        deliveryDate: {
          required
        },
        transportMean: {
          required
        },
        grossWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        },
        netWeight: {
          quantity: {
            required
          },
          unit: {
            required
          }
        }
      }
    },
    mounted() {
      this.depots = window.appCfg.depots
      if (this.$route.params.id !== undefined) this.load(this.$route.params.id)
    },
    computed: {
      sortedRows: function() {
        return this.fields.details.sort((p1, p2) => {
          if (p1['pos'] < p2['pos']) return -1
          if (p1['pos'] > p2['pos']) return 1
          return 0
        })
      }
    },
    methods: {
      abort() {
        if (!this.edit) {
          this.$router.push('/carico')
          return
        }
        this.$fire({
          title: '',
          html: "Annullare tutte le modifiche?",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Conferma'
        }).then(result => {
          if (result.value) {
            this.$router.push('/carico')
          }
        })
      },
      load: function(id) {
        let params = {
          action: 'load',
          id: id
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.edit = false
              this.fields = response.data.data
              // Converto in data
              this.fields.orderDate = new Date(this.fields.orderDate)
              this.fields.deliveryDate = new Date(this.fields.deliveryDate)
            } else {
              this.$fire({
                html: 'Errore di sistema: ' + response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
      },
      reload() {
        this.edit = false
        if (this.$route.params.id) {
          this.load(this.$route.params.id)
        } else {
          this.fields = {
            id: 0,
            details: [],
            orderDate: new Date(),
            deliveryDate: new Date(),
            deliveryNote: '',
            transportMean: '',
            pos: '',
            depot: 0,
            numeroMagazzino: '',
            grossWeight: {
              quantity: '',
              unit: 'KG'
            },
            netWeight: {
              quantity: '',
              unit: 'KG'
            }
          }
        }
      },
      print(row) {
        axios.get('/print/etichetta').then(response => {
          if (response.data) {
            document.getElementById('print-container').innerHTML = response.data.replace('{DN}', this.fields.deliveryNote)
            .replace('{POS}', this.fields.pos)
            .replace('{MN}', row.materialNumber)
            .replace('{TIPO}', row.description)
            .replace('{DATA}', this.fields.orderDate)
            .replace('{DEP}', this.depots[this.fields.depot])
            .replace('{NUMMAG}', this.fields.numeroMagazzino)
            printJS({ printable: 'print-container', type: 'html', documentTitle: '', header: '' })
          }
        })
        // .catch(function (error) {
        //   this.$fire({
        //     html: 'Errore di sistema',
        //     type: 'error'
        //   })
        // })
      },
      onDeleteRow: function(row) {
        this.$fire({
          title: 'Cancellare la riga?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.$http
              .post(
                '/data/carico',
                { action: 'delete', what: 'row', id: row.id },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(deleteResponse => {
                if (deleteResponse.data.done) {
                  this.$fire({
                    title: 'Cancellata!',
                    type: 'success'
                  }).then(r => {
                    this.load(this.$route.params.id)
                  })
                } else {
                  this.$fire({
                    html: deleteResponse.data.message,
                    type: 'error'
                  }).then(r => {
                    if (response.data.bu != '') {
                      this.$router.push(response.data.bu)
                    }
                  })
                }
              })
          }
        })
      },
      onSaveRow: function(data) {
        let params = {
          action: 'save',
          what: 'row',
          headerid: this.fields.id,
          data: data
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.showEditRowDialog = false
              this.load(this.fields.id)
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      onSavePalletRow: function(data) {
        this.showEditSSCCDialog = false
        let params = {
          action: 'save',
          what: 'pallet',
          rowid: data.rowId,
          data: data
        }
        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.showEditSSCCDialog = false
              this.load(this.fields.id)
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      modify() {
        this.edit = true
      },
      save() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        this.fields.orderDate = moment(String(this.fields.orderDate)).format('YYYY-MM-DD')
        this.fields.deliveryDate = moment(String(this.fields.deliveryDate)).format('YYYY-MM-DD')

        let params = {
          action: 'save',
          what: 'head',
          data: this.fields
        }

        let loading = this.$loading.show();
        this.$http
          .post('/data/carico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.edit = false
              if (!this.fields.id) this.fields.id = response.data.id
              //   this.$fire({
              //     html: 'Ordine di carico salvato',
              //     type: 'success',
              //     showCloseButton: true,
              //     showCancelButton: false
              //   }).then(r => {
              //     this.$router.push('/carico')
              //   })
            } else {
              this.$fire({
                html: response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
          .catch(function(error) {
            loading.hide()
            ErrorService.error('Errore di sistema: ' + error.response ? error.response : error.message)
          })
      },
      addSSCC(rowId) {
        this.showEditSSCCDialog = true
        this.editSSCData = {
          id: 0,
          rowId: rowId,
          number: '',
          pallet: '',
          rotto: false
        }
      },
      editSSCC(row) {
        this.editSSCData = {
          id: row.id,
          rowId: 0,
          number: row.number,
          pallet: row.pallet,
          rotto: row.rotto
        }
        this.showEditSSCCDialog = true
        console.log(this.editSSCData)
      },
      brokenSSCC(row) {
        this.$http
          .post(
            '/data/carico',
            { action: 'broken', what: 'pallet', id: row.id , rotto : !row.rotto},
            { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
          )
          .then(deleteResponse => {
            if (deleteResponse.data.done) {
              row.rotto = !row.rotto
            } else {
              this.$fire({
                html: deleteResponse.data.message,
                type: 'error'
              })
            }
          })
      },
      removeSSCC(row) {
        this.$fire({
          title: 'Cancellare il pallet?',
          html: "Non sar&agrave; possibile annullare l'operazione",
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Cancella'
        }).then(result => {
          if (result.value) {
            this.$http
              .post(
                '/data/carico',
                { action: 'delete', what: 'pallet', id: row.id },
                { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } }
              )
              .then(deleteResponse => {
                if (deleteResponse.data.done) {
                  this.$fire({
                    title: 'Cancellato!',
                    type: 'success'
                  }).then(r => {
                    this.load(this.$route.params.id)
                  })
                } else {
                  this.$fire({
                    html: deleteResponse.data.message,
                    type: 'error'
                  }).then(r => {
                    if (response.data.bu != '') {
                      this.$router.push(response.data.bu)
                    }
                  })
                }
              })
          }
        })
      },
      addRow() {
        this.showEditRowDialog = true
        this.editRowData = {
          id: 0,
          pos: '',
          materialNumber: '',
          description: '',
          pcsUnitQuantity: '',
          pcsUnitUnit: 'PAL',
          packagingAmountQuantity: '',
          packagingAmountUnit: 'PAL',
          quantityQuantity: '',
          quantityUnit: 'PC',
          weightQuantity: '',
          weightUnit: 'KG'
        }
      },
      onEditRow(row) {
        this.editRowData = {
          id: row.id,
          pos: row.pos,
          materialNumber: row.materialNumber,
          description: row.description,
          pcsUnitQuantity: row.pcsUnit.quantity,
          pcsUnitUnit: row.pcsUnit.unit,
          packagingAmountQuantity: row.packagingAmount.quantity,
          packagingAmountUnit: row.packagingAmount.unit,
          quantityQuantity: row.quantity.quantity,
          quantityUnit: row.quantity.unit,
          weightQuantity: row.weight.quantity,
          weightUnit: row.weight.unit
        }
        this.showEditRowDialog = true
      },
      close() {}
    }
  }

</script>

<style>

  .md-content.fullScreen {
    width: 100%;
    max-width: 100%;
    padding: 10px 0;
  }
  .md-table .md-table-content {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
  .desc {
    max-width: 320px;
  }
  tr.md-table-row > td {
    text-align: left;
  }
  .sscc > td {
    border-top: 0px !important;
  }
  .ssccList {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .ssccNumber {
    /* max-width: 200px; */
    /* width: 200px; */
    text-align: left;
    display: flex;
    align-items: center;
    min-width: 20%;
    justify-content: space-between;
  }
  .md-field .md-error {
    display: block !important;
    left: 0;
    opacity: 0;
    transform: translate3d(0, -8px, 0);
  }
  .md-field .md-count,
  .md-field .md-error,
  .md-field .md-helper-text {
    height: 20px;
    position: absolute;
    bottom: -22px;
    font-size: 12px;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .md-field.md-invalid .md-error {
    opacity: 1;
    transform: translateZ(0);
  }
  .md-invalid .md-error,
  .md-invalid label {
    color: #ff1744;
  }
  .field-wrapper {
    display: flex;
    max-width: 220px;
    width: 100%;
    justify-content: space-between;
  }
  .field-wrapper > .md-field:first-child {
    max-width: 65%;
  }
  .field-wrapper > .md-field:last-child {
    max-width: 25%;
  }
  .ssccToolbar {
    max-width: 150px;
    width: 150px;
    display: flex;
    align-items: baseline;
  }

</style>



// WEBPACK FOOTER //
// src/components/CaricoEdit.vue